<template>
  <v-container class="pa-0 ma-0 about-page">
    <h1 class="show-title mb-10" style="margin-left: -12px;">
      {{ content.title }}
    </h1>

    <v-row>
      <v-col class="col-12 pa-0">
        <h3>
          Project from NOVA is the Winner of the Horizon Impact Award 2020
        </h3>
        <div class="mt-2 about-stories-body">
          <p>
            <b
              >Elvira Fortunato, is the winner of the European prize Horizon
              Impact Award 2020. INVISIBLE</b
            >, the only Portuguese project among the 10 finalists, was
            distinguished on September 23, 2020 during the event
            <i>"European Research and Innovation Days”</i>.
          </p>
          <p>
            The INVISIBLE project, by scientist and NOVA's Vice-Rector,
            Professor Elvira Fortunato, allowed the development of the first
            display produced with eco-sustainable materials, currently marketed
            by several companies. It is a new technological area at the service
            of different industries such as inkjet printing and smart medical
            diagnostics.
            <b>INVISIBLE</b> was developed at the Centro de Investigação de
            Materiais (CENIMAT), of Faculdade de Ciências e Tecnologia da NOVA,
            in partnership with SAMSUNG.
          </p>
          <p>
            "Horizon Impact Award 2020" distinguishes the projects funded by the
            European Union under the Horizon 2020 programme, whose results
            created social impact in Europe and the world.
          </p>
          <p>Check the highlight of the European Commission:</p>
          <youtube player-width="100%" video-id="kuqHUvinXfE"></youtube>
        </div>

        <v-row>
          <v-col
            v-for="(story, i) in stories"
            :key="i"
            class="col-6 col-md-3 col-lg-4 pt-6"
          >
            <StoryCard :content="story" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StoryCard from '@/components/StoryCard'

export default {
  name: 'Stories',
  components: { StoryCard },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stories: [
        {
          title: 'SCENT.IR - Diagnostics in a breath',
          description:
            'Non-invasive diagnostics of human infections is the future! Know more about this challenging electronic nose & #SCENT_project, funded by the European Research Council (ERC). Find out more in: <a target="_blank" href="https://sites.fct.unl.pt/biomolecular_eng/">https://sites.fct.unl.pt/biomolecular_eng</a>',
          youtubeLink: 'https://www.youtube.com/watch?v=7m6uqpB9vzU',
          youtubeRef: '7m6uqpB9vzU',
        },
        {
          title: 'Developing a pocket-size test for COVID-19',
          description:
            'STAB VIDA, a company that is part of the NOVA University Lisbon ecosystem, has developed a convenient and integrated technological solution to facilitate the testing of COVID-19.',
          youtubeLink: 'https://www.youtube.com/watch?v=q6U1PzAHPUQ',
          youtubeRef: 'q6U1PzAHPUQ',
        },
        {
          title: 'From fighting cancer to COVID-19',
          description:
            'CellmAbs is a NOVA Spin-off that is using its knowledge and exploring ways of leveraging its innovative cancer therapies in the fight against COVID-19.',
          youtubeLink: 'https://www.youtube.com/watch?v=aSxdGVFA8Xk',
          youtubeRef: 'aSxdGVFA8Xk',
        },
        {
          title:
            'Necessity is the mother of invention - Examples that come from patients',
          description:
            'Patient Innovation is an online platform led by NOVA Professors Pedro Oliveira and Helena Canhão, where patients and caregivers around the world connect to share and create solutions to cope with a health-related problem.',
          youtubeLink: 'https://www.youtube.com/watch?v=EdHKNsoAiM4',
          youtubeRef: 'EdHKNsoAiM4',
        },
        {
          title:
            'NOVA alumni fostering entrepreneurship - UpHill success story',
          description:
            'UpHill develops quality analysis software and advanced training for hospitals. Through the use of their products, health professionals increase the degree of adoption of international good practices. By using UpHill solutions health units increase the quality and safety of healthcare provided.',
          youtubeLink: 'https://www.youtube.com/watch?v=dYXszDQ4Noc',
          youtubeRef: 'dYXszDQ4Noc',
        },
        {
          title:
            'com@Rehab project - Santander-NOVA Collaborative Research Award',
          description:
            'Communication for interactive rehabilitation using virtual reality.',
          youtubeLink: 'https://www.youtube.com/watch?v=9niMMnFWWRk',
          youtubeRef: '9niMMnFWWRk',
        },
      ],
    }
  },
}
</script>
